import React, { SyntheticEvent, useCallback, useState } from "react";

interface ModalProps {
  height?: number | string;
  width?: number | string;
  title?: string;
  onClose?: () => void;
}

const useModal = <T extends React.FC<any>>(
  Component: T,
): [React.FC<React.ComponentProps<T> & ModalProps>, () => void, boolean] => {
  const [open, setOpen] = useState(false);
  const toggleModal = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const ModalComponent: React.FC<React.ComponentProps<T> & ModalProps> =
    useCallback(
      (props) => {
        if (!open) return null;

        const { title, onClose, ...componentProps } = props;

        const handleClose = () => {
          if (onClose) {
            onClose();
          }
          setOpen(false);
        };

        if (Component) {
          return (
            <div>
              {/* Backdrop */}
              <div
                className="fixed inset-0 bg-black bg-opacity-70 z-[101]"
                onClick={handleClose}
              />

              {/* Dialog */}
              <div className="fixed inset-0 z-[101] flex items-center justify-center pointer-events-none">
                <div
                  className="w-[90%] md:w-[465px] pointer-events-auto"
                  onClick={(event: SyntheticEvent) => {
                    event.stopPropagation();
                  }}
                >
                  <div className="bg-modal text-modal-text rounded-lg shadow-xl overflow-hidden w-full h-auto">
                    {/* Header */}
                    {title && (
                      <div className="bg-modal-header text-modal-text px-4 h-[42px] flex items-center justify-between">
                        <h2 className="text-white text-20 font-bold">
                          {title}
                        </h2>
                        <button
                          onClick={handleClose}
                          className="text-white cursor-pointer"
                          aria-label="Close"
                        >
                          <i className="au-i-x-rounded-thin text-11"></i>
                        </button>
                      </div>
                    )}

                    {/* Content */}
                    <Component
                      {...({ ...componentProps, onClose: handleClose } as any)}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        }
      },
      [open, Component],
    );

  return [ModalComponent, toggleModal, open];
};

export default useModal;
